module.exports = __webpack_public_path__ + "static/media/arrow.da7a61c7.svg";